import { render, staticRenderFns } from "./widgetIframe.vue?vue&type=template&id=6c2ee5cc&scoped=true&"
import script from "./widgetIframe.vue?vue&type=script&lang=js&"
export * from "./widgetIframe.vue?vue&type=script&lang=js&"
import style0 from "./widgetIframe.vue?vue&type=style&index=0&id=6c2ee5cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ee5cc",
  null
  
)

export default component.exports